import React from "react";

import { Button } from "@material-ui/core";

import { useTranslation } from "react-i18next";

import { useHistory } from "react-router-dom";

import LoginContent from "./LoginContent";

import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
} from "components/CloseableDialog";

export default function CustomizedDialogs() {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClose = () => {
    history.goBack();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="login-dialog-title"
      open
    >
      <DialogTitle id="login-dialog-title" onClose={handleClose}>
        {t("login.title")}
      </DialogTitle>
      <DialogContent>
        <LoginContent />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose} color="primary">
          {t("login.cancelButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
